import React from 'react'
import {
  GridContainer,
  GridItem,
  DescriptionText,
  HighLighted,
  DescriptionTitle,
  NotAllowedRootArea,
  ErrorContainer,
  ErrorMessageContainer,
  AlertIcon
} from './NotAllowed.styles'
import { useViewport } from '@chilecompra/react-kit'

import { Typography } from '@chilecompra/react-kit/components'
import { PUBLIC_URL } from '../../config/settings/environment'

/**
 * Not Allowed Container.
 */
const NotAllowedContainer = () => {
  const {
    size: { isDesktop }
  } = useViewport()

  return (
    <NotAllowedRootArea>
      <GridItem xs={12}>
        <GridContainer>
          <GridItem xs={12} sm={9}>
            <GridItem container alig xs={12}>
              <DescriptionTitle>Participantes del proceso de compra</DescriptionTitle>
            </GridItem>
            <GridItem xs={12} lg={12}>
              <DescriptionText>
                Los participantes corresponden a todas aquellas personas que estuvieron involucradas en algún paso del
                proceso de compra o contratación. Esta información es
                <HighLighted> privada </HighLighted> y solamente es accesible para Fiscalía, Contraloría y Ministerio
                Público
              </DescriptionText>
            </GridItem>
          </GridItem>
          <ErrorContainer item container xs={12} justifyContent="center" alignContent="center">
            <GridItem container xs={12} sm={9} md={9} lg={7} justifyContent="center" alignContent="center">
              <ErrorMessageContainer>
                <AlertIcon alt="Icono de alerta" src={`${PUBLIC_URL}/assets/images/custom_alert_icon.svg`} />
                <Typography
                  fontSize="16px"
                  lineHeight="21px"
                  color="black3"
                  padding={isDesktop ? '0 10px 0 37px' : '20px'}
                  variant="body2"
                >
                  La entidad compradora correspondiente no ha ingresado el listado de funcionarios asociados a esta
                  compra pública.
                </Typography>
              </ErrorMessageContainer>
            </GridItem>
          </ErrorContainer>
        </GridContainer>
      </GridItem>
    </NotAllowedRootArea>
  )
}

export default NotAllowedContainer
